<pos-stepper #cdkStepper linear="true" (selectionChange)="enableForms($event)" [selectedIndex]="selectedIndex">
  <cdk-step label="Información General" [stepControl]="generalnformationForm" [optional]="true">
    <pos-general-information-step [generalnformationForm]="generalnformationForm"></pos-general-information-step>
  </cdk-step>
  <cdk-step label="Enlace de Aval" *ngIf="showRepresentativeStep()" [stepControl]="bankRepresentativeForm">
    <app-bank-representative-step [bankRepresentativeForm]="bankRepresentativeForm"
      [isEdit]="isDraft"></app-bank-representative-step>
  </cdk-step>
  <cdk-step label="Datos de Cliente" [stepControl]="companyInformationForm" [optional]="true">
    <pos-company-information-step [companyInformationForm]="companyInformationForm"
      [onbaseCatalogue]="onbaseCatalogue"></pos-company-information-step>
  </cdk-step>
  <cdk-step label="Información de Ubicacion Empresa" [stepControl]="companyAddressInformationForm" [optional]="true">
    <pos-company-address-information-step [companyAddressInformationForm]="companyAddressInformationForm"
      [onbaseCatalogue]="onbaseCatalogue" [isEdit]="isDraft"></pos-company-address-information-step>
  </cdk-step>
  <cdk-step label="Información de Contacto / Encargado de pago" [stepControl]="companyContactInformationForm"
    [optional]="true">
    <pos-company-contact-information-step [companyContactInformationForm]="companyContactInformationForm"
      [isEdit]="isDraft" [onbaseCatalogue]="onbaseCatalogue"></pos-company-contact-information-step>
  </cdk-step>
  <cdk-step label="Información de Referencias Bancarias / Comerciales" [stepControl]="companyBankingReferenceForm"
    [optional]="true">
    <pos-company-bank-references-step [companyBankingReferenceForm]="companyBankingReferenceForm" [isEdit]="isDraft"
      [onbaseCatalogue]="onbaseCatalogue"></pos-company-bank-references-step>
  </cdk-step>
  <cdk-step label="Observaciones" [stepControl]="observationForm" [optional]="true">
    <pos-observations-step [observationForm]="observationForm"></pos-observations-step>
  </cdk-step>
  <cdk-step label="Documentos" [stepControl]="documentsForm" [optional]="true">
    <pos-documents-step [documentsForm]="documentsForm"></pos-documents-step>
  </cdk-step>
  <cdk-step label="Vista Previa">
    <app-credit-request-save-step [forms]="getMap()" [onbaseCatalogue]="onbaseCatalogue"
      (reconfigureForms)="reenableForms()" (createRequest)="createRequest($event)" (gotoStep)="goToStep($event)"
      [resetInput]="selectedIndex" [customerType]="customer.customerType"></app-credit-request-save-step>
  </cdk-step>
</pos-stepper>